const replenishmentShowroom = {

    ui: {},

    init: function () {
        this.bindUI();
        this.bindEvents();
        this.initInputs();
    },
    bindUI: function () {
        this.ui.$form = $('.js-replenishment-showroom-form')
        this.ui.$addReference = $('.js-replenishment__addReference');
        this.ui.$deleteReference = $('.js-replenishment__deleteReference');
        this.ui.$subBtn = $('.js-subBtn');
        this.ui.$addBtn = $('.js-addBtn');
        this.ui.$subBtnReturnableSamples = $('.js-subBtn-returnable-samples');
        this.ui.$addBtnReturnableSamples = $('.js-addBtn-returnable-samples');

        this.ui.$replenishmentInput = $('.js-replenishment-input');
        this.ui.$replenishmentSubmit = $('.js-replenishment-submit');
        this.ui.$replenishmentAutocomplete = $(".js-replenishment-autocomplete");

        this.ui.$disableBtnFabric = $('.js-disable-btn-fabric');
    },
    bindEvents: function () {
        const self = this
        this.ui.$addReference.on('click', this.addReference.bind(this));
        this.ui.$deleteReference.on('click', this.deleteReference.bind(this));

        this.ui.$addBtn.each(function (e, addBtn) {
            $(addBtn).on('click', self.addBtn);
        })

        this.ui.$subBtn.each(function (e, subBtn) {
            $(subBtn).on('click', self.subBtn);
        })

        this.ui.$addBtnReturnableSamples.each(function (e, addBtnReturnableSamples) {
            $(addBtnReturnableSamples).on('click', self.addBtnReturnableSamples);
        })

        this.ui.$subBtnReturnableSamples.each(function (e, subBtnReturnableSamples) {
            $(subBtnReturnableSamples).on('click', self.subBtnReturnableSamples);
        })

        this.ui.$deleteReference.each(function (e, deleteRef) {
            $(deleteRef).on('click', self.deleteReference.bind(self));
        })

        $('.js-replenishment-quantity').on('change', function(e){
            const quantityContainer = e.currentTarget.closest('.js-replenishment-quantity-container')
            const isFromUs = quantityContainer.dataset.isFromUs === '1'
            const minValue = isFromUs ? 1 : 0
            if(isNaN(e.currentTarget.value) || e.currentTarget.value < minValue){
                e.currentTarget.value = minValue
            }

            if(e.currentTarget.value > 300){
                e.currentTarget.value = 300
            }
        })

        $('.js-replenishment-quantity-returnable-samples').on('change', function(e){
            if(isNaN(e.currentTarget.value) || e.currentTarget.value < 0){
                e.currentTarget.value = 0
            }

            if(e.currentTarget.value > 300){
                e.currentTarget.value = 300
            }
        })


        this.ui.$disableBtnFabric.on('click', this.disableBtnFabric.bind(this));

        this.ui.$replenishmentSubmit.on('click', this.onReplenishmentSubmitClick.bind(this));
        // this.ui.$replenishmentInput.on('keyup', this.keyupPictureInput.bind(this)); // vu qu'on les créé dinamiquement, il faut le bind autrement
        $("body").on('keyup', '.js-replenishment-input', this.keyupPictureInput.bind(this));

        // this.ui.$replenishmentInput.on('keypress', this.hyjackEnterPictureInput.bind(this)); // vu qu'on les créé dinamiquement, il faut le bind autrement
        $("body").on('keypress', '.js-replenishment-submit', this.hyjackEnterPictureInput.bind(this));
        $("body").on('click', () => {
            this.ui.$replenishmentAutocomplete.addClass("js-hide")
        });
    },
    hyjackEnterPictureInput: function (e) {
        var $this = $(e.currentTarget);
        if (event.which == '13') {
            event.preventDefault();
            $this.closest('.js-replenishment').find('.js-replenishment-submit').click();
        }
    },
    keyupPictureInput: function (e) {
        var $this = $(e.currentTarget);
        // console.log(event.which);
        if (event.which == '13' || event.which == undefined) {
            event.preventDefault();
            $this.closest('.js-replenishment').find('.js-replenishment-submit').click();
        } else {
            if (event.which != '39' && event.which != '40') {
                $.ajax({
                    method: 'POST', url: $this.attr('data-target-autocomplete'), data: $this.val(), success: (data) => {
                        if (data.success) {
                            var $autocomplete = $this.closest('.js-replenishment').find(".js-replenishment-autocomplete");
                            $autocomplete.html("").removeClass("js-hide");
                            for (var i = 0; i < data.results.length; i++) {
                                var itemVal = data.results[i];
                                var $autocompleteItem = $("<button type='button' class='projectPictureSearch__autocomplete-item js-replenishment-autocomplete-item' value='" + itemVal + "'>" + itemVal + "</button>");
                                $autocomplete.append($autocompleteItem);
                                $autocompleteItem.on('click', (e) => {
                                    $this.val(e.currentTarget.value);
                                    $this.focus();
                                    $this.closest('.js-replenishment').find('.js-replenishment-submit').click();
                                });
                            }
                        }
                    }, error: (data) => {
                        console.log("error autocomplete");
                    }
                })
            }
        }
    },
    addReference: function (e) {
        e.preventDefault();
        let list = document.getElementById('reference-fields-list');
        let counter = list.dataset.widgetCounter;
        counter++;
        let prototype = list.dataset.prototype;
        let newWidget = prototype.replace(/__name__/g, counter);

        let li = document.createElement('li');
        li.innerHTML = newWidget;

        $(li).find('.js-replenishment-submit').on('click', this.onReplenishmentSubmitClick.bind(this));

        list.appendChild(li);
        list.dataset.widgetCounter = counter;

        $(li).find('.js-replenishment__deleteReference').on('click', this.deleteReference.bind(this));
        $(li).find('.js-addBtn').on('click', this.addBtn.bind(this));
        $(li).find('.js-subBtn').on('click', this.subBtn.bind(this));
        $(li).find('.js-replenishment-quantity').on('change', function(e){
            const quantityContainer = e.currentTarget.closest('.js-replenishment-quantity-container')
            const isFromUs = quantityContainer.dataset.isFromUs === '1'
            const minValue = isFromUs ? 1 : 0
            if(isNaN(e.currentTarget.value) || e.currentTarget.value < minValue){
                e.currentTarget.value = minValue
            }

            if(e.currentTarget.value > 300){
                e.currentTarget.value = 300
            }
        });
        $(li).find('.js-addBtn-returnable-samples').on('click', this.addBtnReturnableSamples.bind(this));
        $(li).find('.js-subBtn-returnable-samples').on('click', this.subBtnReturnableSamples.bind(this));
        $(li).find('.js-replenishment-quantity-returnable-samples').on('change', function(e){
            if(isNaN(e.currentTarget.value) || e.currentTarget.value < 0){
                e.currentTarget.value = 0
            }

            if(e.currentTarget.value > 300){
                e.currentTarget.value = 300
            }
        });

        this.reorder();
    },
    deleteReference: function (e) {
        e.preventDefault();
        e.currentTarget.closest('li').remove()
        this.reorder();
    },
    addBtn: function (e) {
        const quantityContainer = e.currentTarget.closest('.js-replenishment-quantity-container')
        let $inputQuantity = $(quantityContainer).find('.js-replenishment-quantity')
        let currentValue = parseInt($inputQuantity.val());
        if (isNaN(currentValue)) {
            $inputQuantity.val(1);
        } else {
            if (currentValue < 300) {
                $inputQuantity.val(currentValue + 1);
            }
        }
    },
    addBtnReturnableSamples: function (e) {
        const quantityContainerCC = e.currentTarget.closest('.js-replenishment-quantity-returnable-samples-container')
        let $inputQuantityCC = $(quantityContainerCC).find('.js-replenishment-quantity-returnable-samples')
        let currentValueCC = parseInt($inputQuantityCC.val());
        if (isNaN(currentValueCC)) {
            $inputQuantityCC.val(0);
        } else {
            if (currentValueCC < 300) {
                $inputQuantityCC.val(currentValueCC + 1);
            }
        }
    },
    subBtn: function (e) {
        const quantityContainer = e.currentTarget.closest('.js-replenishment-quantity-container')
        const isFromUs = quantityContainer.dataset.isFromUs === '1'
        let $inputQuantity = $(quantityContainer).find('.js-replenishment-quantity')
        let currentValue = parseInt($inputQuantity.val());
        if (isNaN(currentValue)) {
            $inputQuantity.val(1);
        } else {
            const minValue = isFromUs ? 1 : 0
            if (currentValue > minValue) {
                $inputQuantity.val(currentValue - 1);
            }
        }
    },
    subBtnReturnableSamples: function (e) {
        const quantityContainerCC = e.currentTarget.closest('.js-replenishment-quantity-returnable-samples-container')
        let $inputQuantityCC = $(quantityContainerCC).find('.js-replenishment-quantity-returnable-samples')
        const isFromUs = quantityContainerCC.dataset.isFromUs === '1'
        let currentValueCC = parseInt($inputQuantityCC.val());
        if (isNaN(currentValueCC)) {
            $inputQuantityCC.val(0);
        } else {
            const minValue = isFromUs ? 1 : 0
            if (currentValueCC > minValue) {
                $inputQuantityCC.val(currentValueCC - 1);
            }
        }
    },
    initInputs: function () {
        $('.js-replenishment-reference-input option:selected').each(function (i, el) {
            let $container = $(el).parents('.js-replenishment-container');
            $container.find('.js-replenishment-input').val(el.text);
            // $container.find('.js-replenishment-submit').click();
        });
        $('.js-replenishment-container').each(function (i, el) {
            let $container = $(el);
            if ($container.find('.js-replenishment-input').val() !== '') {
                $container.find('.js-replenishment-submit').click();
            }
        });
    },
    onReplenishmentSubmitClick: function (e) {
        let $this = $(e.currentTarget);
        let $container = $this.parents('.js-replenishment-container');
        let $input = $container.find('.js-replenishment-input')
        const input = $input.val()
        let $product = $container.find('.js-replenishment-product');
        let $productInput = $product.find('.js-replenishment-reference-input');
        let $error = $container.find('.js-replenishment-error')
        $productInput.empty();
        if ('' !== input) {
            $.ajax({
                method: 'GET', url: ($this.data('url') + input),
            }).done(function (data) {
                if ('success' === data.status) {
                    let $projectPicture = $container.find('.js-replenishment');
                    let $img = $product.find('.js-replenishment-product-img');
                    let $code = $product.find('.js-replenishment-product-code');
                    let $family = $product.find('.js-replenishment-product-family');
                    let $name = $product.find('.js-replenishment-product-name');
                    $projectPicture.addClass('js-hide');
                    $product.removeClass('js-hide');

                    const env = $img.attr('data-env');
                    const path = ('dev' === env ? '' : $img.attr('data-asset-url')) + '/' + data.product.image;

                    $img.attr('src', path);
                    $code.html(data.product.code);
                    $family.html(data.product.family);
                    $name.html(data.product.name);

                    $container.find('.js-replenishment-product-delete').click(function () {
                        $projectPicture.removeClass('js-hide');
                        $product.addClass('js-hide');
                        $input.val(null);
                        $img.attr('src', '');
                        $code.html(null);
                        $family.html(null);
                        $name.html(null);
                        $productInput.val(null);
                        $productInput.change();
                    })

                    $productInput.val(data.product.code);
                    $productInput.change();
                    $error.html("");
                } else if ('error' === data.status) {
                    $error.html(data.error);
                }
            })
        }
    },
    disableBtnFabric: function (e) {
        let $this = $(e.currentTarget);
        let $container = $this.parents('.js-disable-btn-container');
        const disable = $this.data('disable');
        $container.find(`.js-disable-input-fabric`).addClass('disabled').addClass('js-hide').prop('required', false);
        $container.find(`.js-disable-input-fabric[data-disable="${disable}"]`).removeClass('disabled').removeClass('js-hide').prop('required', true);
    },
    reorder: function () {
        $(".js-replenishment-reference-index").each(function (index, element) {
            $(element).text(index + 1)
        })
    }
}

module.exports = replenishmentShowroom;